import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// ---- Auth (shared password / bearer token) ----
const TOKEN_KEY = "rsr_auth_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

// Attach the token to every request.
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// On 401, drop the bad token and bounce back to the login gate.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearToken();
      if (typeof window !== "undefined") window.location.reload();
    }
    return Promise.reject(err);
  }
);

// Verify a candidate password against the backend (hits the auth'd /stats route).
export const verifyPassword = async (password) => {
  try {
    await axios.get(`${API}/stats`, {
      headers: { Authorization: `Bearer ${password}` },
    });
    return true;
  } catch (e) {
    if (e?.response?.status === 401) return false;
    throw e; // network/other errors bubble up
  }
};

export const COST_CATEGORIES = [
  { key: "plyty", label: "Płyty" },
  { key: "zawiasy", label: "Zawiasy" },
  { key: "nozki", label: "Nóżki" },
  { key: "uchwyty", label: "Uchwyty" },
  { key: "paliwo", label: "Paliwo" },
  { key: "blat", label: "Blat" },
  { key: "fronty", label: "Fronty" },
  { key: "inne", label: "Inne" },
  { key: "robocizna", label: "Wynagrodzenie pracowników" },
];

export const emptyCosts = () =>
  COST_CATEGORIES.reduce((acc, c) => ({ ...acc, [c.key]: 0 }), {});

export const formatPLN = (n) => {
  const v = Number(n || 0);
  return new Intl.NumberFormat("pl-PL", {
    style: "currency",
    currency: "PLN",
    maximumFractionDigits: 2,
  }).format(v);
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("pl-PL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(new Date(iso));
  } catch {
    return "—";
  }
};
